import { render, staticRenderFns } from "./part-1-global.vue?vue&type=template&id=1de9f819&"
import script from "./part-1-global.vue?vue&type=script&lang=js&"
export * from "./part-1-global.vue?vue&type=script&lang=js&"
import style0 from "./part-1-global.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports